import React from 'react';
import { Box, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/BannerSection/BannerSection.styles';

const BannerSectionSkeleton: React.FC = () => {
  return (
    <StyledBox>
      <Box className="BSContent">
        <Skeleton variant="text" width="60%" height={57.6} sx={{ mb: 3 }} />
        <Skeleton variant="text" width="50%" height={92.4} />
      </Box>
    </StyledBox>
  );
};

export { BannerSectionSkeleton };
